








































































import Vue from 'vue';
import ElementUI from 'element-ui';
import * as api from '@/api';
import MainSearch from '../Search.vue';
import HeaderVs from './HeaderVs.vue';
import HeaderNews from './HeaderNews.vue';

export default Vue.extend({
    components: {
        MainSearch,
        HeaderVs,
        HeaderNews,
    },
    data() {
        return {
            more: false,
            nav: [
                {
                    id: 1,
                    name: '标准数据库',
                    path: '/products',
                },
                {
                    id: 2,
                    name: '工具库',
                    path: '/bimtool',
                },
                {
                    id: 4,
                    name: '关于制造商',
                    path: '/about-manufacturer',
                },
                {
                    id: 5,
                    name: '关于我们',
                    path: '/about',
                },
            ],
        };
    },
    computed: {
        unreadCount() {
            return this.$store.state.unreadCount;
        },
        user() {
            return this.$store.state.user;
        },
        compareListCount(): number {
            return this.$store.state.compareList.length;
        },
        searchKeyword: {
            get(): string {
                return this.$store.state.searchKeyword;
            },
            set(val) {
                this.$store.commit('searchKeyword', val);
            },
        },
    },
    watch: {
        user: {
            handler(val) {
                if (val) {
                    this.$store.dispatch('getUnreadCount');
                }
            },
            immediate: true,
        },
    },
    methods: {
        async getUnreadCount() {
            const res = await api.getUnreadCount();
            if (!api.error(res)) {
                this.unreadCount = res.data;
            }
        },
        login() {
            this.more = false;
            this.$store.commit('loginVisible', true);
        },
        logout() {
            this.$store.commit('logout');
            window.location.reload();
        },
        search() {
            this.$router.push({
                path: '/search-results',
                query: {
                    keyword: this.searchKeyword as string,
                },
            });
            this.searchKeyword = '';
            (this.$refs.search as ElementUI.Input).blur();
        },
    },
});
